import { LogsFilters } from '../types';

export const DEFAULT_FILTERS: LogsFilters = {
    includeSources: [],
    includeSourcesIps: [],
    includeSourceIpOrName: [],
    includeDestinations: [],
    includeDestinationsIps: [],
    includeDestinationsIpOrName: [],
    includeDestinationsApplications: []
};
